import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/main.css'

// Tutoriel d'onboarding
import 'driver.js/dist/driver.css'
import './assets/styles/onboardingTour.css'

// Icons fontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Daysjs
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
dayjs.locale('fr')

// Toaster
import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

import {
  faUser,
  faHouse,
  faShirt,
  faEye,
  faPen,
  faTrash,
  faChevronUp,
  faChevronDown,
  faChartLine,
  faTags,
  faRotate,
  faUtensils,
  faCar,
  faUserTag,
  faShoppingCart,
  faGamepad,
  faFilm,
  faMusic,
  faBook,
  faDumbbell,
  faPlane,
  faHeart,
  faGift,
  faCoffee,
  faWallet,
  faCreditCard,
  faPiggyBank,
  faHandHoldingUsd,
  faReceipt,
  faCalculator,
  faTag,
  faBuilding,
  faGraduationCap,
  faMedkit,
  faPhone,
  faWifi,
  faBolt,
  faWater,
  faTv,
  faNewspaper,
  faUmbrella,
  faPaw,
  faBaby,
  faTools,
  faPaintBrush,
  faCamera,
  faQuestion,
  faPlus,
  faArrowDown,
  faArrowUp,
  faTimes,
  faHeartPulse,
  faLaptop,
  faUsers,
  faGear,
  faEnvelope,
  faLock,
  faSignOutAlt,
  faFilter,
  faCoins,
  faCalendar,
  faClock,
  faCopy,
  faChevronLeft,
  faChevronRight,
  faInbox,
  faEnvelopeCircleCheck,
  faCircle,
  faCircleExclamation,
  faMinus,
  faCircleCheck,
  faKey,
  faTriangleExclamation,
  faCheck,
  faEyeSlash,
  faCompass
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUser,
  faHouse,
  faShirt,
  faEye,
  faPen,
  faTrash,
  faChevronUp,
  faChevronDown,
  faChartLine,
  faTags,
  faRotate,
  faUtensils,
  faCar,
  faUserTag,
  faShoppingCart,
  faGamepad,
  faFilm,
  faMusic,
  faBook,
  faDumbbell,
  faPlane,
  faHeart,
  faGift,
  faCoffee,
  faWallet,
  faCreditCard,
  faPiggyBank,
  faHandHoldingUsd,
  faReceipt,
  faCalculator,
  faTag,
  faBuilding,
  faGraduationCap,
  faMedkit,
  faPhone,
  faWifi,
  faBolt,
  faWater,
  faTv,
  faNewspaper,
  faUmbrella,
  faPaw,
  faBaby,
  faTools,
  faPaintBrush,
  faCamera,
  faQuestion,
  faPlus,
  faArrowDown,
  faArrowUp,
  faTimes,
  faGamepad,
  faHeartPulse,
  faLaptop,
  faUsers,
  faGear,
  faEnvelope,
  faLock,
  faSignOutAlt,
  faFilter,
  faCoins,
  faCalendar,
  faClock,
  faCopy,
  faChevronLeft,
  faChevronRight,
  faInbox,
  faEnvelopeCircleCheck,
  faCircle,
  faCircleExclamation,
  faMinus,
  faCircleCheck,
  faKey,
  faTriangleExclamation,
  faCheck,
  faEyeSlash,
  faCompass
)

// Mapping des noms d'icônes vers les objets FontAwesome avec termes de recherche FR/EN
const iconMap = {
  utensils: {
    icon: faUtensils,
    fr: ['ustensiles', 'couverts', 'restaurant', 'manger'],
    en: ['utensils', 'cutlery', 'dining', 'eat']
  },
  car: {
    icon: faCar,
    fr: ['voiture', 'auto', 'transport', 'vehicule'],
    en: ['car', 'vehicle', 'transport', 'auto']
  },
  'user-tag': {
    icon: faUserTag,
    fr: ['utilisateur', 'etiquette', 'tag', 'profil'],
    en: ['user', 'tag', 'profile', 'label']
  },
  'shopping-cart': {
    icon: faShoppingCart,
    fr: ['panier', 'courses', 'achats', 'shopping'],
    en: ['shopping', 'cart', 'basket', 'purchase']
  },
  gamepad: {
    icon: faGamepad,
    fr: ['jeu', 'jeux', 'console', 'manette', 'gaming'],
    en: ['game', 'gaming', 'gamepad', 'console', 'controller']
  },
  film: {
    icon: faFilm,
    fr: ['film', 'cinema', 'video', 'movie'],
    en: ['film', 'movie', 'cinema', 'video']
  },
  music: {
    icon: faMusic,
    fr: ['musique', 'son', 'audio', 'note'],
    en: ['music', 'audio', 'sound', 'note']
  },
  book: {
    icon: faBook,
    fr: ['livre', 'lecture', 'lire', 'education'],
    en: ['book', 'read', 'reading', 'education']
  },
  dumbbell: {
    icon: faDumbbell,
    fr: ['sport', 'musculation', 'gym', 'fitness', 'halter'],
    en: ['sport', 'gym', 'fitness', 'dumbbell', 'workout']
  },
  plane: {
    icon: faPlane,
    fr: ['avion', 'voyage', 'vol', 'transport'],
    en: ['plane', 'flight', 'travel', 'airplane']
  },
  heart: {
    icon: faHeart,
    fr: ['coeur', 'amour', 'sante', 'favori'],
    en: ['heart', 'love', 'health', 'favorite']
  },
  gift: { icon: faGift, fr: ['cadeau', 'present', 'offrir'], en: ['gift', 'present', 'offer'] },
  coffee: { icon: faCoffee, fr: ['cafe', 'boisson', 'tasse'], en: ['coffee', 'drink', 'cup'] },
  wallet: {
    icon: faWallet,
    fr: ['portefeuille', 'argent', 'paiement'],
    en: ['wallet', 'money', 'payment']
  },
  'credit-card': {
    icon: faCreditCard,
    fr: ['carte', 'credit', 'bancaire', 'paiement'],
    en: ['credit', 'card', 'bank', 'payment']
  },
  'chart-line': {
    icon: faChartLine,
    fr: ['graphique', 'statistique', 'courbe', 'analyse'],
    en: ['chart', 'graph', 'statistics', 'analytics']
  },
  'piggy-bank': {
    icon: faPiggyBank,
    fr: ['tirelire', 'epargne', 'economie', 'economies'],
    en: ['piggy', 'bank', 'savings', 'save']
  },
  'hand-holding-usd': {
    icon: faHandHoldingUsd,
    fr: ['argent', 'paiement', 'dollar', 'main'],
    en: ['money', 'payment', 'dollar', 'hand']
  },
  receipt: {
    icon: faReceipt,
    fr: ['recu', 'facture', 'ticket', 'justificatif'],
    en: ['receipt', 'invoice', 'ticket', 'bill']
  },
  calculator: {
    icon: faCalculator,
    fr: ['calculatrice', 'calcul', 'comptabilite'],
    en: ['calculator', 'calculate', 'accounting']
  },
  tag: { icon: faTag, fr: ['etiquette', 'tag', 'label', 'prix'], en: ['tag', 'label', 'price'] },
  building: {
    icon: faBuilding,
    fr: ['batiment', 'immeuble', 'entreprise', 'bureau'],
    en: ['building', 'office', 'company', 'business']
  },
  'graduation-cap': {
    icon: faGraduationCap,
    fr: ['diplome', 'education', 'etudes', 'universite'],
    en: ['graduation', 'education', 'university', 'degree']
  },
  medkit: {
    icon: faMedkit,
    fr: ['medical', 'sante', 'soin', 'docteur'],
    en: ['medical', 'health', 'care', 'doctor']
  },
  phone: {
    icon: faPhone,
    fr: ['telephone', 'appel', 'contact', 'mobile'],
    en: ['phone', 'call', 'contact', 'mobile']
  },
  wifi: {
    icon: faWifi,
    fr: ['wifi', 'internet', 'connexion', 'reseau'],
    en: ['wifi', 'internet', 'connection', 'network']
  },
  bolt: {
    icon: faBolt,
    fr: ['eclair', 'electricite', 'energie', 'rapide'],
    en: ['bolt', 'electricity', 'energy', 'fast']
  },
  water: { icon: faWater, fr: ['eau', 'liquide', 'goutte'], en: ['water', 'liquid', 'drop'] },
  trash: {
    icon: faTrash,
    fr: ['poubelle', 'supprimer', 'effacer', 'corbeille'],
    en: ['trash', 'delete', 'remove', 'bin']
  },
  tv: {
    icon: faTv,
    fr: ['television', 'tele', 'ecran', 'media'],
    en: ['tv', 'television', 'screen', 'media']
  },
  newspaper: {
    icon: faNewspaper,
    fr: ['journal', 'presse', 'actualite', 'news'],
    en: ['newspaper', 'press', 'news', 'journal']
  },
  umbrella: {
    icon: faUmbrella,
    fr: ['parapluie', 'pluie', 'protection'],
    en: ['umbrella', 'rain', 'protection']
  },
  paw: {
    icon: faPaw,
    fr: ['patte', 'animal', 'animaux', 'chien', 'chat'],
    en: ['paw', 'animal', 'pet', 'dog', 'cat']
  },
  baby: { icon: faBaby, fr: ['bebe', 'enfant', 'naissance'], en: ['baby', 'child', 'infant'] },
  tools: {
    icon: faTools,
    fr: ['outils', 'bricolage', 'reparation'],
    en: ['tools', 'repair', 'fix', 'diy']
  },
  'paint-brush': {
    icon: faPaintBrush,
    fr: ['pinceau', 'peinture', 'art', 'dessin'],
    en: ['paint', 'brush', 'art', 'draw']
  },
  camera: {
    icon: faCamera,
    fr: ['camera', 'appareil', 'photo', 'image'],
    en: ['camera', 'photo', 'picture', 'image']
  },
  question: {
    icon: faQuestion,
    fr: ['question', 'aide', 'interrogation'],
    en: ['question', 'help', 'inquiry']
  },
  plus: { icon: faPlus, fr: ['plus', 'ajouter', 'nouveau'], en: ['plus', 'add', 'new'] },
  'arrow-down': {
    icon: faArrowDown,
    fr: ['fleche', 'bas', 'descendre'],
    en: ['arrow', 'down', 'descend']
  },
  'arrow-up': { icon: faArrowUp, fr: ['fleche', 'haut', 'monter'], en: ['arrow', 'up', 'ascend'] },
  times: {
    icon: faTimes,
    fr: ['fermer', 'croix', 'annuler'],
    en: ['times', 'close', 'cancel', 'cross']
  },
  'heart-pulse': {
    icon: faHeartPulse,
    fr: ['coeur', 'sante', 'battement', 'medical'],
    en: ['heart', 'pulse', 'health', 'medical']
  },
  laptop: {
    icon: faLaptop,
    fr: ['ordinateur', 'portable', 'pc', 'informatique'],
    en: ['laptop', 'computer', 'pc']
  },
  users: {
    icon: faUsers,
    fr: ['utilisateurs', 'groupe', 'personnes', 'equipe'],
    en: ['users', 'group', 'people', 'team']
  },
  user: {
    icon: faUser,
    fr: ['utilisateur', 'personne', 'profil', 'compte'],
    en: ['user', 'person', 'profile', 'account']
  },
  house: {
    icon: faHouse,
    fr: ['maison', 'domicile', 'logement'],
    en: ['house', 'home', 'dwelling']
  },
  shirt: {
    icon: faShirt,
    fr: ['chemise', 'vetement', 'habit', 'tshirt'],
    en: ['shirt', 'clothing', 'clothes', 'tshirt']
  },
  eye: {
    icon: faEye,
    fr: ['oeil', 'voir', 'visible', 'regarder'],
    en: ['eye', 'see', 'visible', 'view']
  },
  eyeSlash: {
    icon: faEyeSlash,
    fr: ['oeil', 'voir', 'visible', 'regarder', 'slash', 'cacher'],
    en: ['eye', 'see', 'visible', 'view', 'slash', 'hide']
  },
  pen: {
    icon: faPen,
    fr: ['stylo', 'ecrire', 'editer', 'modifier'],
    en: ['pen', 'write', 'edit', 'modify']
  },
  'chevron-up': {
    icon: faChevronUp,
    fr: ['fleche', 'haut', 'chevron'],
    en: ['chevron', 'up', 'arrow']
  },
  'chevron-down': {
    icon: faChevronDown,
    fr: ['fleche', 'bas', 'chevron'],
    en: ['chevron', 'down', 'arrow']
  },
  rotate: {
    icon: faRotate,
    fr: ['rotation', 'actualiser', 'rafraichir', 'tourner'],
    en: ['rotate', 'refresh', 'reload', 'turn']
  },
  tags: {
    icon: faTags,
    fr: ['etiquettes', 'tags', 'labels', 'categories'],
    en: ['tags', 'labels', 'categories']
  },
  gear: {
    icon: faGear,
    fr: ['engrenage', 'parametre', 'reglage', 'configuration'],
    en: ['gear', 'settings', 'configuration', 'options']
  },
  envelope: {
    icon: faEnvelope,
    fr: ['enveloppe', 'courrier', 'email', 'message'],
    en: ['envelope', 'mail', 'email', 'message']
  },
  lock: {
    icon: faLock,
    fr: ['cadenas', 'verrouiller', 'securite', 'proteger'],
    en: ['lock', 'secure', 'security', 'protect']
  },
  'sign-out-alt': {
    icon: faSignOutAlt,
    fr: ['deconnecter', 'deconnexion', 'sortir', 'logout'],
    en: ['signout', 'logout', 'disconnect', 'exit']
  },
  filter: { icon: faFilter, fr: ['filtre', 'filtrer', 'trier'], en: ['filter', 'sort', 'refine'] },
  coins: {
    icon: faCoins,
    fr: ['pieces', 'monnaie', 'argent', 'devise'],
    en: ['coins', 'money', 'currency']
  },
  calendar: {
    icon: faCalendar,
    fr: ['calendrier', 'date', 'agenda', 'planning'],
    en: ['calendar', 'date', 'schedule', 'agenda']
  },
  clock: {
    icon: faClock,
    fr: ['horloge', 'heure', 'temps', 'montre'],
    en: ['clock', 'time', 'hour', 'watch']
  },
  copy: { icon: faCopy, fr: ['copier', 'dupliquer', 'copie'], en: ['copy', 'duplicate', 'clone'] },
  'chevron-left': {
    icon: faChevronLeft,
    fr: ['fleche', 'gauche', 'chevron', 'precedent'],
    en: ['chevron', 'left', 'arrow', 'previous']
  },
  'chevron-right': {
    icon: faChevronRight,
    fr: ['fleche', 'droite', 'chevron', 'suivant'],
    en: ['chevron', 'right', 'arrow', 'next']
  },
  inbox: {
    icon: faInbox,
    fr: ['boite', 'reception', 'courrier', 'messages'],
    en: ['inbox', 'mail', 'messages', 'receive']
  },
  'envelope-circle-check': {
    icon: faEnvelopeCircleCheck,
    fr: ['enveloppe', 'valide', 'courrier', 'confirme'],
    en: ['envelope', 'check', 'mail', 'confirmed']
  },
  circle: { icon: faCircle, fr: ['cercle', 'rond', 'point'], en: ['circle', 'round', 'dot'] },
  'circle-exclamation': {
    icon: faCircleExclamation,
    fr: ['exclamation', 'alerte', 'attention', 'cercle'],
    en: ['exclamation', 'alert', 'warning', 'circle']
  },
  minus: {
    icon: faMinus,
    fr: ['moins', 'soustraire', 'retirer'],
    en: ['minus', 'subtract', 'remove']
  },
  'circle-check': {
    icon: faCircleCheck,
    fr: ['check', 'valide', 'confirme', 'cercle'],
    en: ['check', 'confirm', 'validated', 'circle']
  },
  key: {
    icon: faKey,
    fr: ['cle', 'mot de passe', 'securite', 'protection'],
    en: ['key', 'password', 'security', 'protection']
  },
  'triangle-exclamation': {
    icon: faTriangleExclamation,
    fr: ['exclamation', 'danger', 'attention', 'triangle'],
    en: ['exclamation', 'danger', 'warning', 'triangle']
  },
  check: {
    icon: faCheck,
    fr: ['check', 'valide', 'confirme', 'cocher'],
    en: ['check', 'confirm', 'validated', 'tick']
  }
}

// Functions
const unixToDate = function (unix, format = 'DD/MM/YYYY') {
  if (unix === null) return null

  const dateDayjs = dayjs.unix(unix)

  if (!dateDayjs.isValid()) return unix

  if (format === 'DD MMMM YYYY') {
    // Première lettre du mois en majuscule
    const day =
      dateDayjs.format('DD')[0] === '0' ? dateDayjs.format('DD')[1] : dateDayjs.format('DD')
    const month = dateDayjs.format('MMMM')
    const year = dateDayjs.format('YYYY')

    return day + ' ' + month.charAt(0).toUpperCase() + month.slice(1) + ' ' + year
  }

  return dateDayjs.format(format)
}

const normalizeString = function (chaine, lower = true) {
  if (!chaine) return null
  let res = chaine
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  if (lower) return res.toLowerCase()

  return res
}

const toCurrencyEUR = function (amount) {
  return amount
    ? amount?.toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      })
    : '0 €'
}

// App
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

// Capacitor
import { Capacitor } from '@capacitor/core'
import { getPlatforms } from '@ionic/vue'
import { StatusBar, Style } from '@capacitor/status-bar'
const isAppCapacitor = Capacitor.isNativePlatform()
const isPhoneFormat = getPlatforms().includes('android') || getPlatforms().includes('ios')

// Sentry
import * as Sentry from '@sentry/capacitor'
import * as SentryVue from '@sentry/vue'

if (isAppCapacitor) {
  // Capacitor n'émet pas l'événement 'deviceready' (pattern Cordova) — appel direct.
  const initStatusBar = async () => {
    try {
      if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setOverlaysWebView({ overlay: false })
        await StatusBar.setStyle({ style: Style.Light })
        // overlay: false = la WebView commence sous la status bar → safe-area-inset-top
        // doit être 0. Mais Android 15+ (edge-to-edge forcé) + viewport-fit=cover
        // rapporte quand même une valeur non-nulle → on la neutralise explicitement.
        document.documentElement.style.setProperty('--safe-area-top', '0px')
        const androidVersion = parseFloat(
          navigator.userAgent.match(/Android (\d+(?:\.\d+)?)/)?.[1] || '0'
        )
        if (androidVersion >= 13) {
          await StatusBar.setBackgroundColor({ color: '#00000000' }) // Transparent
        } else {
          await StatusBar.setBackgroundColor({ color: '#FFFFFF' })
        }
        await StatusBar.show()
      } else {
        await StatusBar.setOverlaysWebView({ overlay: true })
        await StatusBar.setStyle({ style: Style.Default })
      }
    } catch (e) {
      console.log('StatusBar configuration error:', e)
    }
  }
  initStatusBar()
}

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const isProd = import.meta.env.VITE_ENVIRONMENT === 'prod'

Sentry.init(
  {
    environment: isProd ? 'production' : 'development',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    dataCollection: {
      userInfo: false,
      httpBodies: []
    },
    integrations: [
      SentryVue.browserTracingIntegration({ router }),
      ...(!isAppCapacitor ? [SentryVue.replayIntegration()] : [])
    ],
    tracesSampleRate: isProd ? 0.1 : 1.0,
    tracePropagationTargets: ['localhost', import.meta.env.VITE_API_URL],
    replaysSessionSampleRate: !isAppCapacitor ? (isProd ? 0.1 : 1.0) : 0,
    replaysOnErrorSampleRate: !isAppCapacitor ? 1.0 : 0,
    enableLogs: false,
    siblingOptions: { vueOptions: { app } }
  },
  SentryVue.init
)

app.use(pinia)
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(Vue3Toastify, {
  autoClose: 1500,
  theme: 'dark',
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  closeOnClick: true,
  hideProgressBar: false
})

app.config.globalProperties.$isPhoneFormat = isPhoneFormat
app.config.globalProperties.$isAppCapacitor = isAppCapacitor
app.config.globalProperties.$unixToDate = unixToDate
app.config.globalProperties.$dayjs = dayjs
app.config.globalProperties.$toast = toast
app.config.globalProperties.$normalizeString = normalizeString
app.config.globalProperties.$toCurrencyEUR = toCurrencyEUR
app.config.globalProperties.$iconMap = iconMap

app.mount('#app')
